import React, { useState, useEffect } from 'react';
import { FaThumbtack } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import './Menu.css';
import MenuLogo from './MenuLogo';
import UserProfileMenu from '../common/UserProfileMenu';
import tenantStorage from '../../utils/tenantStorage';
import { canAccessMenu } from '../../utils/permissions';
import { useMenuCatalog } from '../../hooks/useMenuCatalog';
import { getMenuIcon } from './menuIcons';

const MENU_PINNED_KEY = 'rt-menu-pinned';

const Menu = ({ activePath }) => {
  const [pinned, setPinned] = useState(() => {
    const stored = tenantStorage.getItem(MENU_PINNED_KEY);
    return stored === null ? true : stored === 'true';
  });
  const navigate = useNavigate();
  const location = useLocation();
  const path = activePath || location.pathname;
  const { menus } = useMenuCatalog();

  const filteredMenuItems = (menus || []).filter((item) => {
    if (!item.enabled) return false;
    if (item.always_show) return true;
    return canAccessMenu(item.key);
  });

  const handleMenuClick = (item) => {
    if (!item.enabled) return;
    if (item.path) {
      navigate(item.path);
    }
  };

  const handlePinClick = () => setPinned((p) => !p);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1280) {
        setPinned(false);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    tenantStorage.setItem(MENU_PINNED_KEY, pinned);
  }, [pinned]);

  return (
    <>
      <div className={`side-menu${pinned ? '' : ' side-menu-unpinned'}`}>
        <div className="menu-header" onClick={() => navigate('/')}>
          <span className="menu-header-icon">
            <MenuLogo />
          </span>
        </div>
        <div
          className="menu-pin"
          onClick={handlePinClick}
          title={pinned ? 'Unpin menu' : 'Pin menu'}
        >
          <FaThumbtack style={{ transform: pinned ? 'rotate(0deg)' : 'rotate(45deg)' }} />
        </div>
        <ul className="menu-list">
          {filteredMenuItems.map((item) => (
            <li
              key={item.key}
              className={`menu-item${!item.enabled ? ' disabled' : ''}${
                item.path && path.startsWith(item.path) ? ' selected' : ''
              }`}
              title={item.label}
              onClick={() => handleMenuClick(item)}
            >
              <span className="menu-icon">{getMenuIcon(item.icon)}</span>
              <span className="menu-label">{item.label}</span>
            </li>
          ))}
        </ul>
        {pinned && (
          <div className="menu-footer">
            <div className="menu-footer-content">
              <div className="menu-footer-links">
                <a href="/terms" className="menu-footer-link">Terms & Conditions</a>
                <span className="menu-footer-separator">•</span>
                <a href="/contact" className="menu-footer-link">Contact Us</a>
                <span className="menu-footer-separator">•</span>
                <a href="/about" className="menu-footer-link">About Us</a>
              </div>
              <div className="menu-footer-version">
                v{process.env.REACT_APP_VERSION || 'Test Version'}
              </div>
            </div>
          </div>
        )}
      </div>
      <UserProfileMenu />
    </>
  );
};

export default Menu;
